import { getData } from "./rest-api-helper"

export async function fileUploadService(file) {
    const res = await getData({ urlPath: "/s3/new" });

    const res01 = await s3FileUpload({ urlPath: res.url, file })

    // if (res01.status === 200 || res01.status === 201)
    return res.key;
}


async function s3FileUpload({ urlPath, file }) {
    // var body = new FormData();
    // body.append('file', file);

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', file.type);

    let res = await fetch(urlPath, { method: 'PUT', headers: myHeaders, body: file });

    if (res.status === 200 || res.status === 201)
        return res;
    else
        // eslint-disable-next-line no-throw-literal
        throw "apiError"
};

export async function getFileUrl({ fileKey }) {
    const details = {
        urlPath: "/s3/get",
        queryParams: { key: fileKey }
    }

    const res = await getData(details);
    return res.data.url;
}